<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('edit') }} {{ $t('offer.tag.tag') }}
                <template v-if="isLoaded && tag.name"> - {{ tag.name }} </template>

                <div
                    v-if="isLoaded"
                    class="pull-right"
                >
                    <router-link
                        v-if="tag.name"
                        :to="{
                            name: 'offers.tags.show',
                            params: { id: tagId },
                        }"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('offer.tag.backToTag') }}</span>
                        <span class="hidden-xs">{{ $t('offer.tag.backToTag') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-arrow-left"></i>
                        </span>
                    </router-link>

                    <router-link
                        v-else
                        :to="{ name: 'offers.tags.list' }"
                        class="btn btn-sm btn-default"
                    >
                        <span class="sr-only">{{ $t('offer.tag.tagsList') }}</span>
                        <span class="hidden-xs">{{ $t('offer.tag.tagsList') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-list-ul"></i>
                        </span>
                    </router-link>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <OffersTagsForm
                            v-show="isLoaded"
                            :tagId="tagId"
                            @loaded="onLoaded"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import OffersTagsForm from '@/components/offers/tags/OffersTagsForm.vue';

export default {
    components: {
        OffersTagsForm,
    },
    data() {
        return {
            isLoaded: false,
            tagId: Number(this.$route.params.id),
            tag: {},
        };
    },
    computed: {
        headTitle() {
            return this.tag.name && `${this.$t('offer.tag.tag')} ${this.tag.name} ${this.$t('edit')}`;
        },
    },
    methods: {
        onLoaded(tag) {
            this.tag = tag;
            this.isLoaded = true;
        },
    },
};
</script>
